// extracted by css-extract-rspack-plugin
export default {"prescriptionsWidget":"prescriptionsWidget-IfChQs"};